import * as types from "./featured.actionTypes";
import { AnyAction } from "redux";
import { initialState } from "./featured.initialState";

export const apiFeaturedReducer = (state = initialState, action: AnyAction) => {
  switch (action.type) {
    case types.GET_FEATURED_LIST_SUCCESS: {
      return {
        ...state,
        featuredList: action.payload,
      };
    }

    case types.SET_USER_SUB: {
      const { languageCode, srtUrl } = action.payload;

      return {
        ...state,
        userSubLanguage: {
          languageCode,
          srtUrl,
        },
      };
    }

    case types.RESET_USER_SUB: {
      return {
        ...state,
        userSubLanguage: {
          languageCode: null,
          srtUrl: null,
        },
      };
    }

    default:
      return state;
  }
};
